import { Box, Container, Text, useToast, VStack } from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logos/s-logo.svg";
import Button from "components/Button/Button";
import PinInput from "components/Input/PinInput";
import constant from "config/constant";
// import { post } from "util/axiosLib";
import secondsToMilliseconds from "date-fns/secondsToMilliseconds";
import useAuth from "hooks/useAuth";
import { useEffect, useRef, useState } from "react";
import Recaptcha from "react-google-recaptcha";
import { useHistory, useLocation } from "react-router-dom";
import { useVerify2faMutation } from "services/arbitraryApi";
import Forgot2FA from "./components/Forgot2FA";



const TwoFaEnter = () => {
  const pinMax = 6;
  const toast = useToast();
  const history = useHistory();
  const location = useLocation();
  const [activeView, setActiveView] = useState("");

  const searchParams = new URLSearchParams(location.search);

  const recaptchaInstanceRef = useRef();
  const [pin, setPin] = useState("");

  const { login } = useAuth();

  const [hasCompleteValues, setHasCompleteValues] = useState(false);

  const [verify2fa, { isLoading, isSuccess, isError, error, data }] =
    useVerify2faMutation();

  const getError = (error) => {
    function isObj(obj) {
      var type = typeof obj;
      return type === "function" || (type === "object" && !!obj);
    }
    const value = isObj(error) ? Object.values(error)[0] : error;
    // console.log("ERROR VALUE", value);
    return value ?? "An unexpected error occurred";
  };

  const handlePin = (pin) => {
    const isValid = String(pin).length === pinMax;
    if (!isValid) setHasCompleteValues(false);
    setPin(pin);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (navigator.onLine === true) {
      const captcha = await recaptchaInstanceRef.current?.executeAsync();
      const reqData = { twoFaCode: pin, humanKey: captcha };
      //   console.log("PIN", pin, reqData);

      try {
        const response = verify2fa(reqData);
        console.log(response, "RESPONSE");
        await recaptchaInstanceRef.current?.executeAsync();
      } catch (error) {
        console.log(error, "ERROR");
      }
    } else {
      toast({
        position: "bottom-right",
        title: "Network Error!!",
        description: "Please check your network connection",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  // const handleSubmit2 = async (e) => {
  //   e.preventDefault();

  //   const headers = {
  //     Authorization: token,
  //     "Content-Type": "application/json",
  //     accept: "application/json",
  //   };

  //   if (navigator.onLine === true) {
  //     console.log("hello here", pin);
  //     setLoading(true);
  //     try {
  //       const captcha = await recaptchaInstanceRef.current?.executeAsync();
  //       const URL = `${process.env.REACT_APP_API_ENDPOINT}/auth/2fa/verifyUser?humanKey=${captcha}`;

  //       // const response = await post(URL, {
  //       //   ...headers,
  //       //   twoFaCode: pin,
  //       // });

  //       const response = await post(URL, { twoFaCode: pin }, headers);

  //       if (response.status === "success") {
  //         setLoading(false);

  //         console.log(response.data, "DATA SUCCESS");
  //         toast({
  //           position: "bottom-right",
  //           title: "Success",
  //           description: response.data.message,
  //           status: "success",
  //           duration: 9000,
  //           isClosable: true,
  //         });
  //         history.replace(constant.PAGES.HOME);
  //       }

  //       if (response.status === 201) {
  //         setLoading(false);

  //         toast({
  //           position: "bottom-right",
  //           title: "Success",
  //           description: response.data.message,
  //           status: "success",
  //           duration: 9000,
  //           isClosable: true,
  //         });

  //         history.replace(constant.PAGES.HOME);
  //       }

  //       if (response.status === 202) {
  //         setLoading(false);

  //         toast({
  //           position: "bottom-right",
  //           title: "Success",
  //           description: response.data.message,
  //           status: "success",
  //           duration: 9000,
  //           isClosable: true,
  //         });

  //         history.replace(constant.PAGES.HOME);
  //       }
  //     } catch (error) {
  //       setLoading(false);
  //       console.log(error, "DATA error here");
  //       await recaptchaInstanceRef.current?.reset();
  //       toast({
  //         position: "bottom-right",
  //         title: "Oops!",
  //         description: error.error,
  //         status: "error",
  //         duration: 18000,
  //         isClosable: true,
  //       });
  //     }
  //   } else {
  //     toast({
  //       position: "bottom-right",
  //       title: "Network Error!!",
  //       description: "Please check your network connection",
  //       status: "error",
  //       duration: 9000,
  //       isClosable: true,
  //     });
  //   }
  // };

  console.log(
    "HAS REDIRECT",
    searchParams.has("redirectUrl"),
    searchParams.get("redirectUrl")
  );

  useEffect(() => {
    (async () => {
      // console.log("AUTH FROM 2FA ENTER", token);
      if (isSuccess && data) {
        console.log("2FA VERIFICATION RESULT", data);
        await recaptchaInstanceRef.current?.reset();

        (() => {
          console.log("GOT HERE :: 2FA ENTER LOGIN");
          login(data?.token, secondsToMilliseconds(data?.exp), true);
        })();

        if (searchParams.has("redirectUrl")) {
          history.replace(searchParams.get("redirectUrl"));
        } else {
          history.replace(constant.PAGES.HOME);
        }
        // props.login()
      }

      if (isError && error) {
        console.log("2FA VERIFICATION ERROR", error);
        await recaptchaInstanceRef.current?.reset();
        toast({
          position: "bottom-right",
          title: "Oops!!",
          description: getError(error?.data?.error),
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    })();

    // eslint-disable-next-line
  }, [isSuccess, data, isError, error, toast, history, login]);

  if(activeView === "2fa_reset") return <Forgot2FA />

  return (
    <VStack py={["10px", "20px"]} minH="100vh" alignItems="center">
      <Container maxW="container.sm">
        <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
          <VStack>
            <Box w={["100px", "initial"]} as={Logo} />
            {/* <Heading as="h3" fontSize={["24px", "32px"]}>
              Welcome
            </Heading> */}
            <Text
              textAlign="center"
              fontSize={["32px", "2xl"]}
              mt="24px !important"
            >
              Enter 2FA code
            </Text>
            <Text
              textAlign="center"
              fontSize={["sm", "md"]}
              color="#4e4b66"
              mt="24px !important"
            >
              Enter code below
            </Text>
          </VStack>

          <Box as="form" mt="50px" onSubmit={handleSubmit}>
            <VStack>
              <PinInput
                isRequired
                limit={pinMax}
                size="lg"
                onChange={handlePin}
                onComplete={() => setHasCompleteValues(true)}
              />

              <Recaptcha
                ref={recaptchaInstanceRef}
                sitekey={process.env.REACT_APP_RECAPTCHA}
                size={"invisible"}
              />

              <Button
                disabled={!hasCompleteValues || isLoading}
                isLoading={isLoading}
                minW="204px"
                minH="56px"
                fontWeight="normal"
                mt="30px !important"
                type="submit"
              >
                Submit
              </Button>
            </VStack>
          </Box>
        </Box>
        <Box mt="5rem" onSubmit={()=>{}} >
          <VStack display="flex" justifyContent="center">
            <Button
                disabled={isLoading}
                onClick={() => setActiveView("2fa_reset")}
                minW="204px"
                minH="56px"
                fontWeight="normal"
                mt="30px !important"
                color="#03A438"
                bg="#fff"
              >
                Reset Your 2FA
              </Button>
            </VStack>
          </Box>
      </Container>
    </VStack>
  );
};

export default TwoFaEnter;
